import { Box, Flex, type FlexProps, forwardRef } from '@chakra-ui/react'
import React from 'react'

interface WrapProps extends FlexProps {
  bottomHR?: boolean
}

const Wrap = forwardRef<WrapProps, 'div'>((props, ref) => {
  const { children, bottomHR = true, sx = {}, ...rest } = props
  return (
    <Box
      {...rest}
      sx={
        bottomHR
          ? {
              mb: '120px',
              pb: '120px',
              borderBottom: '1px solid #3c3c431f',
              ...sx
            }
          : {
              pb: '120px',
              ...sx
            }
      }
    >
      {bottomHR}
      <Flex
        maxW="1296px"
        mx="auto"
        px={{ base: '20px', lg: '48px' }}
        justifyContent={{ base: 'center', lg: 'space-between' }}
        py="10px"
        mb="2px"
      >
        {children}
      </Flex>
    </Box>
  )
})
export default Wrap
